document.addEventListener("DOMContentLoaded", function() {
  const blocks = document.querySelectorAll(".highlight-circles-section");
  blocks.forEach(block => {
    const desktopSize = block.dataset.circleSizeDesktop || 120;
    const mobileSize = block.dataset.circleSizeMobile || 120;

    const circles = block.querySelectorAll('.highlight-circle');
    circles.forEach(circle => {
      circle.style.width = desktopSize + 'px';
      circle.style.height = desktopSize + 'px';
      circle.style.flexShrink = 0;
    });
  });

  const items = document.querySelectorAll(".highlight-item");
  items.forEach(item => {
    item.addEventListener("click", () => {
      const mediaUrl = item.getAttribute("data-media");
      const modal = document.createElement("div");
      modal.classList.add("highlight-modal");

      let contentHTML = "";
      if(mediaUrl.includes("youtube.com") || mediaUrl.includes("youtu.be")) {
        let embedUrl = mediaUrl.replace("watch?v=", "embed/");
        contentHTML = `<iframe width="560" height="315" src="${embedUrl}?autoplay=1" frameborder="0" allowfullscreen></iframe>`;
      } else if(mediaUrl.includes("vimeo.com")) {
        let vidId = mediaUrl.split("/").pop();
        contentHTML = `<iframe src="https://player.vimeo.com/video/${vidId}?autoplay=1" width="560" height="315" frameborder="0" allowfullscreen></iframe>`;
      } else if(mediaUrl.includes("instagram.com")) {
        contentHTML = `<iframe src="${mediaUrl}/embed" width="400" height="480" frameborder="0" scrolling="no" allowtransparency="true" allow="autoplay; encrypted-media;"></iframe>`;
      } else if(mediaUrl.includes("tiktok.com")) {
        contentHTML = `<iframe src="${mediaUrl}/embed" width="325" height="580" frameborder="0" scrolling="no" allow="autoplay; fullscreen;"></iframe>`;
      } else {
        contentHTML = `<video src="${mediaUrl}" controls autoplay></video>`;
      }

      modal.innerHTML = `<div class="highlight-modal-content"><span class="highlight-modal-close">&times;</span>${contentHTML}</div>`;
      document.body.appendChild(modal);

      modal.querySelector(".highlight-modal-close").addEventListener("click", () => {
        document.body.removeChild(modal);
      });
    });
  });
});
